<div class="flex items-center relative">
  @if (user) {
    <div class="mr-3 text-right">
      <div class="font-bold">{{ user.fullName }}</div>
      <div class="text-sm text-secondary">{{ user.email }}</div>
    </div>
  }

  <p-button
    (onClick)="toggleDropdown($event)"
    icon="pi pi-user"
    aria-label="Account menu"
    pTooltip="Account menu"
    [rounded]="true"
    [text]="true">
  </p-button>

  @if (isOpen) {
    <div class="absolute right-0 top-12 bg-white border border-gray-200 rounded-md shadow-lg py-1 z-50 min-w-[150px]">
      <button 
        type="button"
        (click)="onProfileClick()" 
        class="w-full text-left px-4 py-2 hover:bg-gray-100 flex items-center gap-2 text-gray-700 border-none bg-transparent cursor-pointer text-sm">
        <i class="pi pi-user"></i>
        <span>My Profile</span>
      </button>
      <div class="border-t border-gray-100 my-1"></div>
      <button 
        type="button"
        (click)="onLogoutClick()" 
        class="w-full text-left px-4 py-2 hover:bg-gray-100 flex items-center gap-2 text-red-500 border-none bg-transparent cursor-pointer text-sm font-semibold">
        <i class="pi pi-sign-out"></i>
        <span>Sign Out</span>
      </button>
    </div>
  }
</div>